import { render } from "./videoBox.vue?vue&type=template&id=429401ca&scoped=true"
import script from "./videoBox.vue?vue&type=script&lang=js"
export * from "./videoBox.vue?vue&type=script&lang=js"

import "./videoBox.vue?vue&type=style&index=0&id=429401ca&lang=scss"
import "./videoBox.vue?vue&type=style&index=1&id=429401ca&scoped=true&lang=scss"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-429401ca"]])

export default __exports__